export interface DataViewTypes {
  spend: DataViewType;
  ticketTypes: DataViewType;
  topTenTrips: DataViewType;
  passengers: DataViewType;
}

export enum DataViewType {
  CHART = 'chart',
  TABLE = 'table',
}

export const getDataViewType = (type: string): DataViewType => {
  switch (type) {
    case 'chart':
      return DataViewType.CHART;
    case 'table':
      return DataViewType.TABLE;
    default:
      return DataViewType.CHART;
  }
};
